import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { RegistrationComponent } from './registration/registration.component';
import { AppRoutingModule } from './app-routing.module';
import { ProgramComponent } from './program/program.component';
import { HttpClientModule } from '@angular/common/http';
import { ReviewComponent } from './review/review.component';
import { ApplicationComponent } from './application/application.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { PhonePipe } from "src/app/filters/phone.filter";
import { PhoneMaskDirective, AlphaOnlyLessRestricted, NumberOnlyDirective } from "src/app/directives/validation.directive";
import { HomeComponent } from './home/home.component';
import { APP_BASE_HREF } from "@angular/common";
import { RegistrationService } from "src/app/services/registration.servcie";
import { HttpUtilityService } from "src/app/http/http-utility.service";
import { FileUploadService } from "src/app/services/fileupload.service";
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { OwlModule } from 'ngx-owl-carousel';
import { StoreService } from "src/app/services/store.service";
import { AdminComponent } from "src/app/admin/admin.component";
import { LoginComponent } from 'src/app/auth/login.component';
import { AuthGuard } from 'src/app/auth/auth-guard.service';
import { AuthService } from 'src/app/auth/auth.service';
import { ErrorComponent } from './error/error.component';
import { PaginationComponent } from "src/app/pagination/pagination.component";
import { SortDirective } from "src/app/directives/sort.directive";
import { SpinnerModule } from './spinner/spinner.module';
import { LandingComponent } from './main/landing.component';
import { CreateRequestGuardService } from 'src/app/services/navigation-gaurd.service';

@NgModule({
  declarations: [
    AppComponent,
    RegistrationComponent,
    ProgramComponent,
    ReviewComponent,
    ApplicationComponent,
     PhonePipe,
    PhoneMaskDirective,
    AlphaOnlyLessRestricted,
    NumberOnlyDirective,
    HomeComponent,
    ConfirmationComponent,
    AdminComponent,
    LoginComponent,
    ErrorComponent,
    PaginationComponent,
    SortDirective,
    LandingComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    NgMultiSelectDropDownModule.forRoot(),
    RecaptchaModule.forRoot(), RecaptchaFormsModule,
    OwlModule,
    SpinnerModule
  ],
  providers: [
    RegistrationService,
    HttpUtilityService,
    FileUploadService,
    {provide: APP_BASE_HREF, useValue:'/'},
    {provide: RECAPTCHA_SETTINGS,
    useValue: { siteKey: '6LfRaZoUAAAAAHr-7ai-rAKgB-4hzv6OhL1w-mhL' } as RecaptchaSettings},
    StoreService,
    AuthGuard,
    AuthService,
    CreateRequestGuardService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
